import React, { useEffect, useState } from "react";
import {
  CustomPagination,
  PageLoader,
  SearchBar,
} from "../../../Components/Components";
import CreateQuizModal from "./Modals/CreateQuizModal";
import { Table, Tooltip } from "antd";
import { useDispatch } from "react-redux";
import { DeleteQuizAPI, GetQuizzesAPI } from "../../Redux/quiz";
import {
  formatIncomingDate,
  utcToLocalDate,
  utcToLocalDateTime,
} from "../../../helpers/utils";
import svg from "../../../Assets/svg";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { ActionModal } from "../../../Components/Modal/Modal";
import { GetNavbarCounts } from "../../Redux/challenges";

export const QuizStatusTypes = {
  Published: "published",
  Scheduled: "scheduled",
  Draft: "draft",
};

export const renderQuizStatus = (status) => {
  if (!status) {
    <div>-</div>;
  }
  return (
    <div
      className={`${
        status === QuizStatusTypes.Draft
          ? "text-grey"
          : status === QuizStatusTypes.Scheduled
          ? "text-orange"
          : "text-green"
      }`}
    >
      {status === QuizStatusTypes.Draft
        ? "Draft"
        : status === QuizStatusTypes.Scheduled
        ? "Scheduled"
        : "Published"}
    </div>
  );
};

const Quizzes = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [fetching, setFetching] = useState(true);
  const [data, setData] = useState([]);

  const [page, setPage] = useState(1);
  const limit = 15;
  const [totalCount, setTotalCount] = useState();

  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearchValue, setDebouncedSearchValue] = useState("");

  const [isDeletedView, setIsDeletedView] = useState(false);

  const [quizIdToDelete, setQuizIdToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const [quizFormSettings, setQuizFormSettings] = useState({
    isModalOpen: false,
    quizId: "",
  });

  const pageCount = Math.ceil(totalCount / limit);

  const fetchQuizzes = async () => {
    setFetching(true);
    const result = await dispatch(
      GetQuizzesAPI({
        page: page,
        limit: limit,
        search: debouncedSearchValue,
        deleted: isDeletedView,
      })
    );
    if (result?.success) {
      setTotalCount(result.data.total);
      setData(result.data.data);
    }
    setFetching(false);
  };

  useEffect(() => {
    fetchQuizzes();
  }, [page, debouncedSearchValue, isDeletedView]);

  useEffect(() => {
    if (searchValue === "") {
      setDebouncedSearchValue("");
      return;
    }

    const handler = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchValue]);

  const deleteQuizHandler = async () => {
    setDeleting(true);
    await dispatch(
      DeleteQuizAPI(
        quizIdToDelete,
        () => {
          setQuizIdToDelete(null);
          setDeleting(false);
          fetchQuizzes();
          dispatch(GetNavbarCounts());
        },
        () => {
          setDeleting(false);
        }
      )
    );
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: "25%",
    },
    {
      title: "Questions",
      key: "questionLength",
      render: (_, record) => {
        return <div>{record?.questions ? record?.questions?.length : "-"}</div>;
      },
    },
    {
      title: "Start Date",
      key: "startDate",
      render: (_, record) => {
        return (
          <div>
            {record?.published_on
              ? formatIncomingDate(record?.published_on)
              : "-"}
          </div>
        );
      },
    },
    {
      title: "Participants",
      key: "participants",
      render: (_, record) => {
        return (
          <div>
            {record?.participants
              ? record?.participants?.length > 0
                ? record?.participants?.length
                : "-"
              : "-"}
          </div>
        );
      },
    },
    {
      title: "Created Date",
      key: "createdDate",
      render: (_, record) => {
        return (
          <div>
            {record?.created_at ? utcToLocalDateTime(record?.created_at) : "-"}
          </div>
        );
      },
    },
    {
      title: "Status",
      key: "quiz_status",
      render: (_, record) => {
        return (
          <div>{record?.status ? renderQuizStatus(record?.status) : "-"}</div>
        );
      },
    },
    ...(isDeletedView
      ? []
      : [
          {
            title: "Action",
            key: "action",
            render: (_, record) => {
              return (
                <div className="d-flex">
                  <Tooltip title="View Quiz Details">
                    <button
                      className={`d-inline-block ms-2 px-0 py-0`}
                      onClick={() => {
                        navigate(`/admin/quizzes/details/${record._id}`);
                      }}
                    >
                      {svg?.viewQuestionIcon}
                    </button>
                  </Tooltip>
                  <Tooltip title="Delete Quiz">
                    <button
                      className={`d-inline-block ms-2 px-0 py-0`}
                      onClick={(e) => {
                        setQuizIdToDelete(record._id);
                      }}
                    >
                      {svg?.deleteQuestionIcon}
                    </button>
                  </Tooltip>
                </div>
              );
            },
          },
        ]),
  ];

  return (
    <>
      <div className="sidenav_content d-flex flex-column justify-content-between ">
        <div className="container-fluid px-4 py-4 h-100">
          <div className="d-flex flex-column h-100 ">
            {isDeletedView && (
              <div
                className="ack_link mb-md-4 mb-2 d-inline-flex align-items-center fw-bold ff fs-6 text-decoration-none txt-orange cursor-pointer gap-2"
                onClick={(e) => {
                  e.preventDefault();
                  setIsDeletedView(false);
                  setPage(1);
                }}
              >
                <span>{svg?.goBack}</span>
                {"Back"}
              </div>
            )}
            <div className="d-flex flex-wrap justify-content-between mb-md-4 mb-3 align-items-center">
              <h2 className="mb-0 fw-bold ff title-color fs-42 mb-2 mb-xl-0">
                {isDeletedView ? "Deleted Quizzes" : "Quizzes"}{" "}
                {totalCount > 0 && `(${totalCount})`}
              </h2>
              <div className="d-flex flex-wrap align-items-center gap-3 ms-auto">
                <SearchBar
                  value={searchValue}
                  setValue={setSearchValue}
                  searchHandler={(e) => setSearchValue(e.target.value)}
                  placeholder={"Search"}
                  inputClass={"border-25 ps-5 ms-auto"}
                  clearData={() => setSearchValue("")}
                />
                <button
                  className="btn btn-primary btn-lg ku-btn px-4 ms-auto ff"
                  onClick={() => {
                    setQuizFormSettings({
                      isModalOpen: true,
                      quizId: "",
                    });
                  }}
                >
                  + Create
                </button>
              </div>
            </div>

            {fetching ? (
              <div className="d-flex justify-content-center align-items-center vh-100">
                <PageLoader />
              </div>
            ) : (
              <>
                <div className="flex-fill overflow-y-auto d-flex flex-column">
                  <div
                    className="table-wrapper"
                    style={{ flex: 1, overflow: "hidden" }}
                  >
                    <Table
                      dataSource={data}
                      className="antTable custom-antd-table h-100"
                      scroll={{ y: "100%", x: 1124 }}
                      pagination={false}
                      columns={columns}
                    />
                  </div>
                </div>
                <CustomPagination
                  className={`mt-3`}
                  pageId={page}
                  setPageId={setPage}
                  pageCount={pageCount}
                  countCalculation={totalCount ? totalCount : 0}
                  limit={limit}
                  deletedText={isDeletedView ? "" : "Deleted Quizzes"}
                  onDeleteClick={() => {
                    setPage(1);
                    setIsDeletedView(true);
                  }}
                />
              </>
            )}
          </div>
        </div>
      </div>

      {quizFormSettings.isModalOpen && (
        <CreateQuizModal
          isModalOpen={quizFormSettings.isModalOpen}
          onClose={(refetch = false) => {
            if (refetch) {
              fetchQuizzes();
              dispatch(GetNavbarCounts());
            }
            setQuizFormSettings({
              isModalOpen: false,
              quizId: "",
            });
          }}
          onCreate={(id) => {
            setQuizFormSettings({
              isModalOpen: false, 
              quizId: "",
            });
            navigate(`/admin/quizzes/details/${id}`);
          }}
        />
      )}

      <ActionModal
        isOpen={quizIdToDelete !== null}
        title="Delete Quiz, Are You Sure?"
        description={
          "This action will permanently delete the quiz and all related data. Are you sure you want to proceed?"
        }
        buttonText="Yes, Delete"
        isLoading={deleting}
        actionHandler={deleteQuizHandler}
        cancelHandler={() => setQuizIdToDelete(null)}
      />
    </>
  );
};

export default Quizzes;
